interface Point {
	x: number;
	y: number;
}
export function pointInCicle(x: number, y: number, m: number, n: number, r: number): boolean {
	return distance(x, y, m, n) <= r;
}
export function distance(x1: number, y1: number, x2: number, y2: number): number {
	const a = x1 - x2;
	const b = y1 - y2;
	return Math.sqrt(a * a + b * b);
}
/**
 * æ±äºåä¸æ¬¡æ¹ç¨çç³»æ°
 * y1 = k * x1 + b => k = (y1 - b) / x1
 * y2 = k * x2 + b => y2 = ((y1 - b) / x1) * x2 + b
 */
export function binaryEquationGetKB(x1: number, y1: number, x2: number, y2: number) {
	const k = (y1 - y2) / (x1 - x2);
	const b = (x1 * y2 - x2 * y1) / (x1 - x2);
	return [k, b];
}
/**
 * ä¸åäºæ¬¡æ¹ç¨æ±æ ¹
 * axÂ² + bx + c = 0
 */
export function quadEquationGetX(a: number, b: number, c: number) {
	const xArr = [];
	const result = Math.pow(b, 2) - 4 * a * c;
	if (result > 0) {
		xArr.push((-b + Math.sqrt(result)) / (2 * a));
		xArr.push((-b - Math.sqrt(result)) / (2 * a));
	} else if (result === 0) {
		xArr.push(-b / (2 * a));
	}
	return xArr;
}
/**
 * æ±ååç´çº¿ä¹é´çäº¤ç¹
 * ç´çº¿æ¹ç¨ï¼y = kx + b
 * åçæ¹ç¨ï¼(x - m)Â² + (x - n)Â² = rÂ²
 * x1, y1 = çº¿åæ 1, x2, y2 = çº¿åæ 2, m, n = ååæ , r = åå¾
 */
export function getInsertPointBetweenCircleAndLine(
	x1: number,
	y1: number,
	x2: number,
	y2: number,
	m: number,
	n: number,
	r: number
) {
	// åç´çæ²¡ææçï¼è¦ç¹æ®å¤æ­
	if (x1 === x2) {
		const arr: Point[] = [];
		arr.push({ x: x1, y: n + r });
		arr.push({ x: x1, y: n - r });
		return arr;
	}
	// console.log(x1, y1, x2, y2, m, n, r)
	const kbArr = binaryEquationGetKB(x1, y1, x2, y2);
	const k = kbArr[0];
	const b = kbArr[1];

	const aX = 1 + k * k;
	const bX = 2 * k * (b - n) - 2 * m;
	const cX = m * m + (b - n) * (b - n) - r * r;

	const insertPoints: Point[] = [];
	const xArr = quadEquationGetX(aX, bX, cX);
	xArr.forEach(x => {
		const y = k * x + b;
		insertPoints.push({ x: x, y: y });
	});
	return insertPoints;
}
